import moment from 'moment';
import Vuex, { Store, StoreOptions, Getter, ActionContext } from 'vuex';
import { State } from './abstractions';

// Mutations


function setLoading(state: State, loading: boolean) {
    if (loading) {
        state.isLoading += 1;
    }
    else {
        state.isLoading -= 1;
    }
}

function setLang(state: State, lang: string) {
    state.lang = lang;
    moment.locale(lang);
}

function setNavigation(state: State, navigation: any) {
    state.navigation = navigation;
}

function setUIMessage(state: State, message: string) {
    state.uiMessage = message;
}

function clearUIMessage(state: State) {
    state.uiMessage = null;
}

function setUISnackbar(state: State, snackbar: any) {
    state.uiSnackbar = snackbar;
}

function clearUISnackbar(state: State) {
    state.uiSnackbar = null;
}

function setIsDevelopment(state: State, isDevelopment: boolean) {
    state.isDevelopment = isDevelopment;
}

function setMobile(state: State, isMobile: boolean) {
    state.isMobile = isMobile;
}

function resetUI(state: State) {
}

function updateAuthentication(state: State, update: { result: 'OK' | 'ERROR', user: User }) {
    if (update.result == 'OK' && !!update.user) {
        state.isAuthenticated = true;
        update.user.roles = copy(update.user['finder:role']);
        delete update.user['finder:role'];
        if (update.user.roles) {
            if (Array.isArray(update.user.roles)) {
                update.user.roles = update.user.roles.map(r => getRoleObject(r));
            }
            else {
                update.user.roles = [getRoleObject(update.user.roles)];
            }
        }
        state.loggedUser = update.user;
    }
    else {
        state.isAuthenticated = false;
        state.loggedUser = null;
    }
}

function getRoleObject(roleString: string) {
    return JSON.parse(roleString);
}

// Error management

export function checkResult<T>(ctx: ActionContext<State,any>, result: ApiResult<T>) {
    if (result.result == "OK") {
        return result.data || true;
    }
    else {
        return false;
    }
}

// Getters

function hasRole(state: State) {
    return (role: string) => state.loggedUser && state.loggedUser.roles && state.loggedUser.roles.some(x => x.name == role);
}

function hasTranslatorLanguage(state: State) {
    return (lang: string) => {
        if (hasRole(state)('ADMIN')) {
            return true;
        }
        let translator = state.loggedUser && state.loggedUser.roles && state.loggedUser.roles.filter(x => x.name == 'TRANSLATOR')[0];
        if (translator) {
            return translator.languages.includes(lang);
        }
        return false;
    }
}

// Initial state and store options

const state: State = {
    isDevelopment: false,
    isLoading: 0,
    isMobile: false,
    isAuthenticated: false,

    loggedUser: null,

    lang: "en",
    uiMessage: null,
    uiSnackbar: null,
    navigation: null,

    apps: [],
    appVersions: [],
    appVersionSummary: null
}

import { mutations } from './mutations';

import { actions as mainActions } from './actions';
import { actions as graphqlActions } from './graphql-actions';
import appsActions from '../pages/apps/actions';
import settingsActions from '../pages/settings/actions';
import { User } from '@/model';
import { ApiResult } from '@/helpers/api';
import { copy } from '@/helpers';

const OPTIONS : StoreOptions<State> = {
    state,
    actions: {
        ...mainActions,
        ...graphqlActions,
        ...appsActions,
        ...settingsActions
    },
    mutations: {
        setLoading,
        setIsDevelopment,
        setLang,
        resetUI,
        setMobile,
        setNavigation,
        setUIMessage,
        clearUIMessage,
        setUISnackbar,
        clearUISnackbar,
        updateAuthentication,
        ...mutations
    },
    getters: {
        hasRole,
        hasTranslatorLanguage
    }
}

let store: Store<State> = null;

export function getStore() {
    if (store == null) {
        store = new Vuex.Store(OPTIONS);
    }
    return store;
}
